import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'fallbackTableValue'})
export class FallbackTableValue implements PipeTransform {
    transform(value: any, ...args: any[]): any {
        if (value === 0 || value === '' || value === undefined || value === null)
            return '-';
        return value;
    }
}
